<nav *ngIf="Activated" class="navbar {{onTop ? 'nav-bar-pos':'nav-bar-pos-small' }}">
  <div class="container-fluid">
    <div class="navbar-header">
      <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#Navbar">
        <i class="armx-icon armx-menu"></i>
      </button>
      <a class="navbar-brand" href="#"><img class="img-responsive nav-img" src="/assets/img/{{onTop?'aramex-white-logo.png':'aramex-white-logo.png'}}" /><span *ngIf="onTop">{{ 'pages.outletSelection.pos' | translate }}</span></a>
    </div>

    <div class="collapse navbar-collapse" id="Navbar">
      <ul class="nav navbar-nav">
        <!--<li class="active"><a href="#">about</a></li>
        <li><a href="#">hardware</a></li>
        <li><a href="#">features</a></li>
        <li><a href="#">Contact us</a></li>-->
      </ul>
      <!-- <ul class="dropdown-menu">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Services
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <a class="dropdown-item" href="#">English</a>
            <a class="dropdown-item" href="#">French</a>
          </div>
        </li>
        <li><button>English</button></li>
        <li><button>French</button></li>
      </ul> -->
      
      <ul class="nav navbar-nav navbar-{{dir}}">
        <!-- <li>
          <div class="dropdown" style="margin-top:20%">
            <a class="dropdown-toggle" data-toggle="dropdown" href="#">
              Language
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu">
              <li><a (click)="changeLang('ar')">Arabic</a></li>
              <li><a (click)="changeLang('en')">English</a></li>
            </ul>
          </div>

        </li> -->

        <!--<li class="no-image hidden-xs hidden-sm hidden-md">
          <div class="center entity-main-img" (click)="requestChange(true)">
            <span class="armx-icon armx-building"></span>
          </div>
        </li>-->
        <li (click)="requestChange(true)">
          
          <a class="entity-name">
            <span class="armx-icon armx-building"></span>
            {{currentBranch?.branch?.BranchDisplayName}}
            <span class="armx-sort-down txt-super"></span>
          </a>

        </li>

      </ul>
      <ul class="nav navbar-nav navbar-{{dir}} languageDropdown">
        <li>
          <div class="dropdown" style="margin-top:5%">
            <img src="/assets/icons/language.svg" class="languageIcon"/>
            <a class="dropdown-toggle languageBtn" data-toggle="dropdown">
              {{ selectedLanguage }}
              <span class="armx-sort-down txt-super"></span>
            </a>
            <ul class="dropdown-menu">
              <ng-container *ngFor="let lang of languages;let i = index">
                <li class="text-center w-100" [ngClass]="(languages.length != i+1)? 'languageBoarder' : ''"><a class="lng-item-Btn" (click)="changeLang(lang.key)">{{ lang.value }}</a></li>
              </ng-container>
            </ul>
          </div>
        </li>
      </ul>
    </div>

  </div>
</nav>
